import React from 'react';
import { Database } from 'lucide-react';
import ScraperDashboard from '../components/Admin/ScraperDashboard';

/**
 * Admin page for BigFuture college data scraper
 * Manual triggers, queue monitoring, and quality review
 */
const AdminScraper = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white border-b border-gray-200 px-6 py-4">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center gap-3 mb-2">
            <Database className="w-8 h-8 text-blue-600" />
            <h1 className="text-3xl font-bold text-gray-900">
              College Data Scraper
            </h1>
          </div>
          <p className="text-gray-600">
            BigFuture-first deadline extraction, quality monitoring, and manual verification
          </p>
        </div>
      </div>

      {/* Dashboard */}
      <ScraperDashboard />

      {/* Instructions */}
      <div className="max-w-7xl mx-auto px-6 pb-8">
        <div className="mt-8 bg-blue-50 rounded-xl border border-blue-200 p-6">
          <h2 className="text-lg font-semibold text-blue-900 mb-3">
            How It Works
          </h2>
          <div className="space-y-2 text-sm text-blue-800">
            <p>
              <strong>1. BigFuture First:</strong> Scraper extracts deadlines from College Board BigFuture using stable data-testid selectors
            </p>
            <p>
              <strong>2. Official Site Validation:</strong> Cross-references with official college site to detect mismatches
            </p>
            <p>
              <strong>3. Quality Flags:</strong> Automatically flags discrepancies for admin review before updating database
            </p>
            <p>
              <strong>4. Manual Verification:</strong> Colleges marked as manually_verified will not be overwritten unless force update is used
            </p>
            <p>
              <strong>5. Source Attribution:</strong> Every deadline includes source URL and confidence score for verification
            </p>
          </div>
        </div>

        {/* Data Flow */}
        <div className="mt-4 bg-green-50 rounded-xl border border-green-200 p-6">
          <h2 className="text-lg font-semibold text-green-900 mb-3">
            Data Flow
          </h2>
          <div className="space-y-2 text-sm text-green-800">
            <p>
              <strong>Scraper extracts:</strong> Deadlines (ED, EA, RD) with exact dates
            </p>
            <p>
              <strong>Scraper discovers:</strong> Essay page URLs and requirements page URLs
            </p>
            <p>
              <strong>AI extracts later:</strong> Essay prompts and detailed requirements from discovered URLs (in RequirementsFetchOrchestrator)
            </p>
          </div>
        </div>

        {/* Safety Notice */}
        <div className="mt-4 bg-yellow-50 rounded-xl border border-yellow-200 p-4">
          <p className="text-sm text-yellow-800">
            <strong>Safety:</strong> Scraper will never overwrite manually_verified=true colleges unless you explicitly use "Force Update".
            All changes are logged in scrape_history for audit trail.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AdminScraper;
